__turbopack_context__.v({
  "className": "roboto_f591652f-module__3rmnra__className",
});
